import { Address } from '@app/models';
import { Action } from '@ngrx/store';

export enum AuthActionTypes {
  Login = '[Auth] Login',
  LoginSuccess = '[Auth] Login Success',
  LoginFailure = '[Auth] Login Failure',
  Logout = '[Auth] Logout',
  RemoveToken = '[Auth] Remove Token',
  Authenticated = '[Auth] Authenticated',
  AuthenticatedSuccess = '[Auth] Authenticated Success',
  AuthenticatedFailure = '[Auth] Authenticated Failure',
  LoginRedirect = '[Auth] Login Redirect',
  UpdateAuthUser = '[Auth] Update User',
  UpdateAuthUserFail = '[Auth] Update User Fail',
  FetchAuthenticatedUser = '[Auth] Fetch Authenticated User',
  UpdateAuthUserAddress = '[Auth] Update User Address',
  ChangeCredentials = '[Auth] Change credentials'
}

export class Login implements Action {
  readonly type = AuthActionTypes.Login;
  constructor(public payload: any) {}
}

export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LoginSuccess;
  constructor(public payload: any) {}
}

export class LoginFailure implements Action {
  readonly type = AuthActionTypes.LoginFailure;
  constructor(public payload: any) {}
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
}

export class RemoveToken implements Action {
  readonly type = AuthActionTypes.RemoveToken;
}

export class Authenticated implements Action {
  readonly type = AuthActionTypes.Authenticated;
}

export class AuthenticatedSuccess implements Action {
  readonly type = AuthActionTypes.AuthenticatedSuccess;
  constructor(public payload: any) {}
}

export class AuthenticatedFailure implements Action {
  readonly type = AuthActionTypes.AuthenticatedFailure;
  constructor(public payload: any) {}
}

export class LoginRedirect implements Action {
  readonly type = AuthActionTypes.LoginRedirect;
}

export class UpdateAuthUser implements Action {
  readonly type = AuthActionTypes.UpdateAuthUser;
  constructor(public payload: any) {}
}

export class UpdateAuthUserFail implements Action {
  readonly type = AuthActionTypes.UpdateAuthUserFail;
  constructor(public payload: Error) {}
}

export class FetchAuthenticatedUser implements Action {
  readonly type = AuthActionTypes.FetchAuthenticatedUser;
}
export class UpdateAuthUserAddress implements Action {
  readonly type = AuthActionTypes.UpdateAuthUserAddress;
  constructor(public payload: Address) {}
}

export class ChangeCredentials implements Action {
  readonly type = AuthActionTypes.ChangeCredentials;
}

export type AuthActions =
  | Login
  | LoginSuccess
  | LoginFailure
  | Logout
  | RemoveToken
  | Authenticated
  | AuthenticatedSuccess
  | AuthenticatedFailure
  | LoginRedirect
  | UpdateAuthUser
  | UpdateAuthUserFail
  | FetchAuthenticatedUser
  | UpdateAuthUserAddress
  | ChangeCredentials;
